import styles from "../../assets/styles/Wallet/Wallet.module.scss";
import React, { useMemo } from "react";
import {
  AppPage,
  BusinessInsightComponent as BIC,
  PageLoader,
  MimaButton,
  MimaTable,
} from "../../components";
import { amountFormatter } from "../../utils/utils";
import moment from "moment";
import { AnimatePresence } from "framer-motion";
import {
  CreateOutflowModalContainer,
  OutflowReviewModalContainer,
} from "../../containers";
import constant from "../../utils/constant";
import { downloadXlsx2 } from "../../utils/download";

const CreateOutflow = ({
  closeModal,
  createOutflowModal,
  goToCreateOutflow,
  isLoading,
  data,
  isFetching,
  onLimitChange,
  limit,
  setSearchQuery,
  currentPage,
  setCurrentPage,
  reviewOutflowModal,
  goToReviewOutflow,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value.filter((X) => X.type === "OUTFLOW") || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Creation Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const createdAt = cell.row.original.createdAt;
        const formattedCreatedAt = moment(createdAt).format("DD/MM/YYYY");
        return <span>{formattedCreatedAt}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business?.tradingName;
        return <span>{businessName}</span>;
      },
    },
    {
      Header: "Amount",
      accessor: "amountPaid",
      Cell: ({ cell }) => {
        const amount = cell.row.original.amountPaid;
        const currencyCode = cell.row.original.currencyCode;
        const formattedAmount = amountFormatter(currencyCode).format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Vendor",
      accessor: "vendor",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const styleClass = `status ${status === "FULLY-PAID" || status === "PAID" ? "status__green" : status === "PENDING" ? "status__dark__yellow" : status === "VOID" || status === "REVERSED" ? "status__grey" : "status__dark__yellow"}`;
        return <span className={styleClass}>{status}</span>;
      },
    },
    {
      Header: "Action",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        const status = cell.row.original.status;

        return (
          <>
            {status === "PENDING" && (
              <span
                className="tableAction__text"
                onClick={() => {
                  goToReviewOutflow(item);
                }}
              >
                Review Outflow
              </span>
            )}
          </>
        );
      },
    },
  ];

  const printData = tableData.map((item) => {
    const createdBy = item?.createdBy;
    const updatedBy = item?.updatedBy;
    const updatedAt = item?.updatedAt;

    return {
      "Created Date": moment(item.createdAt).format("DD/MM/YY HH:mm"),
      "Business Name": item?.business?.tradingName || "",
      Narration: item?.narration || "",
      "Currency Code": item?.currencyCode || "",
      "Outflow Debit Amount": amountFormatter(item.currencyCode).format(
        item.amountPaid,
      ),
      Status: item?.status || "",
      "Created By": createdBy
        ? `${createdBy?.firstname} ${createdBy?.lastname}`
        : "N/A",
      "Approved By": updatedBy
        ? `${updatedBy?.firstname} ${updatedBy?.lastname}`
        : "N/A",
      "Approved Date": updatedAt
        ? moment(updatedAt).format("DD/MM/YY HH:mm")
        : "",
    };
  });

  return (
    <AppPage pageTitle="Create Outflow">
      {isLoading ? (
        <PageLoader title="While we set things up for you" />
      ) : (
        <>
          <div className={styles.cards}>
            <BIC
              title="Outflow Count"
              amount={tableData.length}
              styleClass="cards_blue_1"
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "1rem",
              flexWrap: "wrap",
              marginTop: "5rem",
            }}
          >
            <MimaButton title="Create Outflow" onClick={goToCreateOutflow} />
            <MimaButton
              title={`Download Outflow Report`}
              width={30}
              onClick={() => {
                downloadXlsx2(
                  printData,
                  `Outflow Report ${moment().format("DD/MM/YYYY")}`,
                );
              }}
              variant="outlined"
            />
          </div>
        </>
      )}
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Outflow"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {(createOutflowModal || reviewOutflowModal) && (
        <div className="modal">
          <AnimatePresence>
            {createOutflowModal && (
              <CreateOutflowModalContainer closeModal={closeModal} />
            )}

            {reviewOutflowModal && (
              <OutflowReviewModalContainer closeModal={closeModal} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default CreateOutflow;
